<template lang="pug">
.admin-shops
  v-toolbar(
    dark
    color="indigo"
    flat)
    v-toolbar-title 店舖列表
    v-spacer
    v-btn(flat outline @click="openForm")
      v-icon add
      span 新增
  v-data-table(
    :headers="headers"
    :items="items")
    template(v-slot:items="{ item }")
      td
        v-btn(icon @click="openForm({ id: item.id, data: item })")
          v-icon edit
      td
        v-btn(icon
          @click="(deleting = item.id, deleteChecker = true)")
          v-icon delete
      td(v-for="header in headers.slice(2)" :key="header.value") {{ item[header.value] }}
  base-full-form-dialog(:actived="formDialog"
    :title="editting.id ? '修改店舖資訊' : '新增店舖'"
    :submitText="editting.id ? '儲存' : '送出'"
    :loading="loading"
    @close="closeForm"
    @submit="editting.id ? getFormData() && updateItem(editting.id, getFormData()) : getFormData() && createItem(getFormData())")
    shop-form(ref="form"
      v-if="formDialog"
      :data="editting.data")
  v-dialog(:value="deleteChecker"
    @)
    v-card
      v-card-title 確定刪除此店舖？
      v-card-actions
        v-btn(@click="deleteChecker = false") 放棄
        v-spacer
        v-btn(
          :loading="loading"
          @click="deleteItem(deleting)") 確定刪除
      check-dialog(:open="checker.open" :title="checker.title")
</template>

<script>
import { mapActions } from "vuex";
import { db, storage } from "@/firebase";
import CheckDialog from "@/components/core/CheckDialog.vue";
import ShopForm from "@/components/forms/ShopForm.vue";
import BaseFullFormDialog from "@/components/core/BaseFullFormDialog.vue";

export default {
  name: "AdminShops",
  components: {
    CheckDialog,
    ShopForm,
    BaseFullFormDialog
  },
  data() {
    return {
      headers: [
        { text: "編輯", value: "edit" },
        { text: "刪除", value: "delete" },
        { text: "店舖名稱", value: "name" },
        { text: "地址", value: "address" },
        { text: "電話", value: "phoneNumber" },
        { text: "服務項目", value: "products" },
        { text: "開店時間", value: "openTime" },
        { text: "負責人", value: "principal" }
      ],
      items: [],
      editting: {
        id: null,
        data: null
      },
      formDialog: false,
      deleteChecker: false,
      checker: {
        open: false,
        title: ""
      },
      loading: false,
      deleting: null
    };
  },
  watch: {
    deleteChecker(val) {
      if (!val) {
        this.deleting = null;
      }
    }
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    ...mapActions(["api"]),
    async fetchItems() {
      const snap = await db.collection("shops").get();

      const items = snap.docs.map(doc => {
        const data = doc.data();
        data.id = doc.id;
        return data;
      }).sort((a, b) => a.order - b.order);
      this.items = items;
    },
    async createItem(form) {
      this.loading = true;
      const res = await this.api({
        method: "POST",
        url: "/shop",
        data: form
      });
      await this.fetchItems();
      this.closeForm();
      this.loading = false;
    },
    async updateItem(id, form) {
      this.loading = true;
      const res = await this.api({
        method: "PATCH",
        url: `/shop/${id}`,
        data: form
      });
      await this.fetchItems();
      this.closeForm();
      this.loading = false;
    },
    async deleteItem(id) {
      this.loading = true;
      const res = await this.api({
        method: "DELETE",
        url: `/shop/${id}`
      });
      await this.fetchItems();
      this.deleteChecker = false;
      this.loading = false;
    },
    openForm({ id = null, data = null }) {
      this.editting = { id, data };
      this.formDialog = true;
    },
    closeForm() {
      this.editting.id = null;
      this.editting.data = null;
      this.formDialog = false;
      this.$refs.form.reset();
    },
    getFormData() {
      return this.$refs.form.submit();
    }
  }
};
</script>
